<template>
    <div>    
        <div class="container">
    
            <CommonBreadcrumb class="bread_block" />

            <div class="pdp_flex mt-4">
                <div class="pdp_flex_left">
                    <!-- {{detailData}} -->
                    <JewelrySlider />
                </div>
                <div class="pdp_flex_right">
                    <JewelryReturnsInfo v-if="['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(detailData.sub_type)" />
                    <JewelryInfo v-else />
                </div>
            </div>
    
        </div>
    
        <div class="container mt-md-5">
            <JewelryHuesDetail v-if="['hues-ring','soiree-ring','soiree-earring'].includes(detailData?.sub_type)"/>
            <JewelryDetail  v-else/>
        </div>
        
        <div class="container mt-5" v-if="$country.payment_banner">
            <CommonPaymentBanner />
        </div>
    
        <div class="container mt-5" v-if="$country.evertreen">
            <EvertreeBanner />
        </div> 
    
        <div v-if="$country.trustpilot" class="container mt-5">
            <HomeTrustpilotReview />
        </div>
    </div>
    </template>
    
    <script setup>
    
        import { useSeo } from '@/composables/seo/setMetaTags'
        import { shopdetailStore }  from '@/stores/shop_detail/shop_detail';

    
        const tags = useSeo();
        const store = shopdetailStore()
    
        const { $country } = useNuxtApp()
        const route = useRoute()
     
        
        const moduleSubType = route.meta.moduleSubType 
    
        
        const detailData = computed(() => {
            return store.getDetailData
        })

        
        
        const userId = computed(() => {
            // if(this.$auth.loggedIn){
            //     return this.$auth.user.id
            // }
            return null
        }) 
    
        const currentMetal = computed(() => {
            return store.getCurrentActive('metal')
        })
    
        const isFastShip = computed(() => {
            const query = route.query

            if( route.params?.type === 'ready-to-ship-engagement-rings' ){

                return true
            }
            if( route.params?.type === 'ready-to-ship-pendants' ){

                return true
            }
            if( route.params?.type === 'ready-to-ship-earrings' ){

                return true
            }

            if(Object.keys(query).length > 0){
                if([false, 'false'].includes(route.query.FastShip)){
                    return false
                }
                if([true, 'true'].includes(route.query.FastShip)){
                    return true
                }
            }
            return false
        })


        // if(import.meta.client) {
        //     await store.setDetailData({ slug: route.params.slug, fullPath: route.path, sub_type: route.params.type, fastShip: isFastShip.value })
        //     // await this.setMetaTags()
        // }

    await useAsyncData('setDetailData', () => store.setDetailData({ slug: route.params.slug, fullPath: route.path, sub_type: route.params.type, fastShip: isFastShip.value }).then(() => true), {
     
    })

        
        await tags.setMetaTags()
    
        onMounted(() => {
         
    
            if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
                cls_InovaDiamonds_Iframe.init_Session_Go()
            }

            if(['full-eternity-ring', 'anniversary-ring', 'band-ring', 'couple-bands-ring', 'in-stock-ring'].includes(detailData.value.sub_type)){ 
                const script = document.createElement('script');
                script.src = 'https://vto.jewelry/?d=6LYC9UW';
                script.async = true;
                script.onload = () => {
                };
                document.head.appendChild(script);
            }
    
        })
    </script>
    
    
    <style scoped>
    
    </style>